import { render, staticRenderFns } from "./ProposalOrder.vue?vue&type=template&id=54696a85&"
import script from "./ProposalOrder.vue?vue&type=script&lang=js&"
export * from "./ProposalOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports